export default defineNuxtRouteMiddleware((_to, _from) => {
	// Middleware is defined in plugins/checkAuth.client.ts
});
